<template>
  <div></div>
</template>

<script>
import Utils from "../utils/Utils";

export default {
  name: "Footer",
  data(){
    return {
      app:"",
    };
  },
  mounted: function()
  {
    this.app=Utils.getApp();
    //this.c=Utils.getCookie('app_hrzp_official');
    console.log(document.cookie)
    // if(this.app=='WeiXin') {
    //   console.log('WeixinJSBridge',window.WeixinJSBridge)
    //   document.addEventListener('WeixinJSBridgeReady',() =>{
    //     window.WeixinJSBridge.call('showToolbar');
    //   });
    //   window.WeixinJSBridge.call('showToolbar');
    // }
  }
}
</script>

<style scoped>
</style>